import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import App from "../components/appPenna";

import InternLinks from "../components/internlinks";
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout>
          <Breadcrumb category={["metoder", "metoder"]}  page={["Tandblekningspenna", "tandblekningspenna"]}/>
     <SEO title="Tandblekningspenna" description="Recension av Tandblekningspenna"/>
    <main className="section-info">
    <section>
    <h1 class="welcome">Tandblekningspenna</h1>
    <p className="text-center">
    En tandblekningspenna är helt enkelt en penna som innehåller tandblekningsgel. Pennan är oftast i storlek som en bläckpenna och har som en liten pensel som man enkelt penslar på gelen på tänderna med.
</p><p className="text-center">
Blekningspenna är bland det enklaste och snabbaste sättet att bleka tänderna. Att pennan är så liten gör att den går att ha med sig på ett smidigt sätt och du behöver inte krångla med skenor eller tandblekingsremsor.
</p><p className="text-center">
Tandblekningspennor fungerar bäst om du redan har blekt tänderna tidigare och nu vill bättra på missfärgningar som har uppstått eller om du helt enkelt vill fräscha upp och förstärka blekningen. Det går dock att använda även om du inte har blekt tänderna tidigare men då ska du helst inte ha för starka missfärgningar. För att få ett tydligt resultat är det vanligast att man använder pennan en – två gånger om dagen till dess att man är nöjd men om du har blekt tidigare kan en användning räcka för att du ska återfå färgen du vill ha.</p>
      <p className="text-center">
      Den är väldigt smidig och ta med om man reser, fester, jobb etc.  
      </p>
    </section>
  </main>
  <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Tandblekningspenna</h2>
     <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
    <App />
    </main>
  </section>
  {/* <section className="section-faq">
    <FAQ />
  </section> */}
     <main className="section-info">
    <section>
    <h3 class="welcome">Vad tycker vi om denna produkt?</h3>
    <p className="text-center">
      Alla pennor fungerar istort lika. Så kolla gärna på antal blekningar man får för pengarna när du köper en penna. 
      Likaså vad mer som tillkommer kan vara värt och titta på.</p>
      <p className="text-center">
      Tandblekningspennor är ett snabbt och enkelt sätt att bleka dina tänder. Tandblekningspennor är också ett sätt att bättra på en tidigare blekning.
      </p><p className="text-center">
      Tandblekningspennan innehåller allt du behöver för att enkelt kunna bleka tänderna hemma och skaffa dig ett vackert vitt leende på 14 dagar.
      </p>
      <ul>Så här gör du:
      <li>1. Pensla på ett tunt lager gel på tänderna med din tandblekningspenna morgon och kväll, efter att du har borstat tänderna.</li>
      <li>2. Håll munnen öppen i 30 sekunder, så att gelen sjunker in innan du stänger den.</li>
      <li>3. Därefter ska du inte äta eller dricka på 30 minuter.</li>
      <li>4. Efter 30 minuter sköljer du munnen med vatten.</li>
      <li>5. Upprepa denna behandling i 14 dagar för bästa resultat.</li>
      </ul>

      
    </section>
  </main>
  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  <main className="section-info">
    <section>
    <h3 class="welcome">Är det någon skilland på andra tandblekningsmetorder och tandblekningspenna?</h3>
    <p className="text-center">
    I en tandblekningspenna används samma tandblekningsgel som när man använder sig av tandskenor. Skillnaden är att tandblekningspennan är ett snabbare och enklare alternativ där man inte behöver ha några skenor i munnen och man inte behöver lägga så mycket tid på blekningen.
    </p><p className="text-center">
    Nackdelen är att den inte fungerar så bra om man inte har blekt tänderna tidigare eller om de är väldigt missfärgade. Det beror på att det är svårare att få ett helt jämnt resultat med pennan och den passar bättre för att bättra på eller bleka enskilda tänder. Precis som white strips skiljer de sig från startkit på så sätt att de helt enkelt passar bäst om du redan blekt tänderna tidigare.</p>
    <p className="text-center">&nbsp;</p><p className="text-center">&nbsp;</p>
    </section>
  </main>
  </Layout>
)

export default IndexPage
